<template>
  <div v-if="isOpen" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
    <div class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg w-full max-w-lg p-6 relative dark:border dark:border-dark-border dark:text-dark-text max-h-[90vh] overflow-y-auto" ref="modal" :style="modalStyle">
      <!-- <h2 class="text-2xl font-semibold mb-6 text-gray-800 dark:text-dark-text">Edytuj Pasażera #{{ localPassenger.id }}</h2> -->
      <div 
        class="cursor-move mb-4 pb-2 border-b dark:border-dark-border"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <h2 class="text-2xl font-bold text-gray-800 dark:text-dark-text">Edytuj Pasażera</h2>
      </div>
      <button @click="closeModal" class="absolute top-4 right-4 text-gray-500 hover:text-gray-700 dark:text-dark-text dark:hover:text-dark-border-hover">
        &times;
      </button>
      <form @submit.prevent="submitEdit" class="space-y-6">

        <!-- Imię -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="firstName">Imię:</label>
          <input
              v-model="localPassenger.firstName"
              id="firstName"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.firstName }"
              @input="validateField('firstName')"
          />
          <span v-if="localErrors.firstName" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.firstName }}</span>
        </div>

        <!-- Nazwisko -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="lastName">Nazwisko:</label>
          <input
              v-model="localPassenger.lastName"
              id="lastName"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.lastName }"
              @input="validateField('lastName')"
          />
          <span v-if="localErrors.lastName" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.lastName }}</span>
        </div>

        <!-- Miasto -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="city">Miasto:</label>
          <input
              v-model="localPassenger.city"
              id="city"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.city }"
              @input="validateField('city')"
          />
          <span v-if="localErrors.city" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.city }}</span>
        </div>

        <!-- Telefon -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="phone">Telefon:</label>
          <input
              v-model="localPassenger.phone"
              id="phone"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.phone }"
              @input="validateField('phone')"
          />
          <span v-if="localErrors.phone" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.phone }}</span>
        </div>

        <!-- Adres Zamieszkania -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="homeAddress">Adres Zamieszkania:</label>
          <input
              v-model="localPassenger.homeAddress"
              id="homeAddress"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.homeAddress }"
              @input="validateField('homeAddress')"
          />
          <span v-if="localErrors.homeAddress" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.homeAddress }}</span>
        </div>

        <!-- Adres Pracy -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1" for="workAddress">Adres Pracy:</label>
          <input
              v-model="localPassenger.workAddress"
              id="workAddress"
              type="text"
              class="block w-full p-2 border rounded-md focus:outline-none focus:ring dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text"
              :class="{ 'border-red-500 dark:border-dark-status-unavailable': localErrors.workAddress }"
              @input="validateField('workAddress')"
          />
          <span v-if="localErrors.workAddress" class="text-red-500 text-sm dark:text-dark-status-unavailable">{{ localErrors.workAddress }}</span>
        </div>

        <!-- Submit -->
        <div class="flex justify-end">
          <button 
            type="submit" 
            class="w-full bg-button-bg text-button-text py-2 rounded-md hover:bg-button-hover focus:outline-none focus:ring focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover" 
            :disabled="hasErrors"
            :class="{ 'opacity-50 cursor-not-allowed': hasErrors }"
          >
            Zapisz zmiany
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
/* Pasek przewijania w trybie ciemnym */
.dark .overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.dark .overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #2c7a7a; /* Teal-700 */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #1a5d5d; /* Ciemniejszy odcień teal dla krawędzi suwaka */
}

.dark .overflow-y-auto::-webkit-scrollbar-track {
  background-color: #333333; /* Ciemne tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

/* Pasek przewijania w trybie jasnym */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px; /* Szerokość paska przewijania */
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #d1d5db; /* Jasnoszary kolor suwaka (szary) */
  border-radius: 8px; /* Zaokrąglenie suwaka */
  border: 2px solid #9ca3af; /* Ciemniejszy szary dla krawędzi suwaka */
}

.overflow-y-auto::-webkit-scrollbar-track {
  background-color: #f3f4f6; /* Jasnoszare tło dla śledzenia paska */
  border-radius: 8px; /* Zaokrąglenie tła paska */
}

.cursor-move {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.dragging {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>

<script>
export default {
  props: {
    isOpen: Boolean,
    editingPassenger: Object,
    companies: Array
  },
  data() {
    return {
      localPassenger: { ...this.editingPassenger },
      localErrors: {
        firstName: '',
        lastName: '',
        city: '',
        phone: '',
        homeAddress: '',
        workAddress: ''
      },
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      modalPosition: { x: 0, y: 0 }
    };
  },
  watch: {
    editingPassenger: {
      handler(newVal) {
        this.localPassenger = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    hasErrors() {
      return Object.values(this.localErrors).some(error => error !== '');
    },
    modalStyle() {
      return {
        transform: `translate(${this.modalPosition.x}px, ${this.modalPosition.y}px)`
      };
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    validateField(field) {
      const passenger = this.localPassenger;
      switch (field) {
        case 'firstName':
          this.localErrors.firstName = passenger.firstName.length < 2 ? "Imię musi mieć co najmniej 2 znaki" : "";
          break;
        case 'lastName':
          this.localErrors.lastName = passenger.lastName.length < 2 ? "Nazwisko musi mieć co najmniej 2 znaki" : "";
          break;
        case 'city':
          this.localErrors.city = passenger.city.length < 2 ? "Miasto musi mieć co najmniej 2 znaki" : "";
          break;
        case 'phone':
          this.localErrors.phone = passenger.phone.length < 9 ? "Numer telefonu musi mieć min. 9 cyfr" : "";
          break;
        case 'homeAddress':
          this.localErrors.homeAddress = passenger.homeAddress.length < 2 ? "Adres zamieszkania musi mieć co najmniej 2 znaki" : "";
          break;
        case 'workAddress':
          this.localErrors.workAddress = passenger.workAddress.length < 2 ? "Adres pracy musi mieć co najmniej 2 znaki" : "";
          break;
      }
    },

    submitEdit() {
      this.validateField('firstName');
      this.validateField('lastName');
      this.validateField('city');
      this.validateField('phone');
      this.validateField('homeAddress');
      // this.validateField('workAddress');

      if (!this.hasErrors) {
        const updatedPassenger = {
          ...this.localPassenger
        };
        this.$emit('submit', updatedPassenger);
      }
    },
    startDrag(event) {
        this.isDragging = true;
        
        event.currentTarget.classList.add('dragging');
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.dragOffset.x = clientX - this.modalPosition.x;
        this.dragOffset.y = clientY - this.modalPosition.y;
        
        // Dodajemy event listeners
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag, { passive: false });
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);
      },
    onDrag(event) {
        if (!this.isDragging) return;
        
        event.preventDefault();
        
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        
        this.modalPosition.x = clientX - this.dragOffset.x;
        this.modalPosition.y = clientY - this.dragOffset.y;
      },
    stopDrag() {
        this.isDragging = false;
        
        const dragElement = document.querySelector('.cursor-move');
        if (dragElement) {
          dragElement.classList.remove('dragging');
        }

        // Usuwamy event listeners
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
      },
    resetPosition() {
        this.modalPosition = { x: 0, y: 0 };
    },
  }
};
</script>
